module.exports = __webpack_public_path__ + "img/moac.7edd6826.svg";